import { render, staticRenderFns } from "./Kings.vue?vue&type=template&id=6f56b629"
import script from "./Kings.vue?vue&type=script&lang=js"
export * from "./Kings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports